// @flow
import React from 'react';
import Icon from './Icon';
import Wrapper from './FormFieldWrapper';

type InputProps = {
  value: string,
  children: any,
  name: string,
  label: string,
  onChange: (number: string) => void,
  className: string,
  required: boolean,
  disableAutofill?: boolean,
  toggleVisibilityButton?: boolean,
  type: string,
  error: string,
  helpText: string,
  ref: string,
  focusOnMount: boolean,
  disabled: boolean,
  maxLength: number,
  helpTextBelow: boolean, /* default: help text hovers to right until bmobile breakpoint.
  adding this makes it below form always */
  noWrapper?: boolean,
  noPlaceholders?: boolean,
  iconName: string,
  showDeleteButton?: boolean,
  onDelete?: () => void,
  upperCase?: boolean,
  numeric?: boolean,
  onFocus?: () => void,
  onBlur?: () => void
}

class TextInput extends React.Component {
  state = {
    showHelpText: false,
    showPassword: false,
    touched: false, // The field was focused and user tried to type something in
    hadValue: false
  }

  props: InputProps

  handleClick = () => {
    this.setState((prevState) => {
      return { showPassword: !prevState.showPassword };
    });
  }

  render() {
    const type = (this.props.type || 'text');
    const icon = this.state.showPassword ? 'close' : 'open';
    const content = (
      <label
        className={`control ${this.props.label && 'has-float-label'} ${this.props.className}`}
        htmlFor={this.props.name}
      >
        {this.props.disableAutofill &&
          <input className={'is-absolutely-hidden'} type='password' name='fakeInput' />
        }
        <input
          className={`input text-input
            ${this.props.error && !this.state.focused && !this.props.disabled ? 'has-error' : ''}
            ${this.props.disabled ? 'is-disabled' : ''}
            `}
          id={this.props.name}
          name={this.props.name}
          ref={this.props.focusOnMount ?
            (input) => input && input.focus() :
            'none'}
          value={this.props.value}
          type={type === 'password' && this.state.showPassword ? 'text' : type}
          placeholder={this.props.label}
          onChange={(e) => {
            if (!this.state.hadValue) this.setState({ hadValue: true });
            const { value } = e.currentTarget;
            if (this.props.upperCase) e.currentTarget.value = value.toUpperCase();
            if (this.props.maxLength && value.length > this.props.maxLength) return;
            if (this.props.numeric && isNaN(Number(value))) return;
            this.props.onChange(e, { touched: this.state.touched });
          }}
          required={this.props.required}
          disabled={this.props.disabled}
          maxLength={this.props.maxLength}
          onFocus={(e) => {
            this.setState({ showHelpText: true, focused: true });
            /* TODO: sucessfully place cursor at *end* of value. Not working. */
            e.target.value = e.target.value;
            if (this.props.onFocus) this.props.onFocus(e);
          }}
          onBlur={(e) => {
            this.setState({ showHelpText: false, focused: false });
            if (this.state.hadValue && !this.state.touched) {
              this.setState({ touched: true });
              this.props.onChange(e, { touched: true });
            }
            if (this.props.onBlur) this.props.onBlur(e);
          }}
          tabIndex={this.props.focusOnMount ? 1 : 0}
        />
        <span className='label-text'>
          {this.props.iconName && <Icon name={this.props.iconName} />}
          {this.props.label}
        </span>
        {this.props.toggleVisibilityButton &&
          <button className='text-input-right-icon visibility-icon' onClick={() => this.handleClick()}>
            <Icon size='medium' name={`eye-${icon}`} />
          </button>
        }
        {this.props.showDeleteButton &&
          <span
            role='button'
            className='text-input-right-icon delete'
            onClick={this.props.onDelete}
            tabIndex={0}
          />
        }
        {this.props.error ? <p className='error-text'>{this.props.error}</p> : ''}

      </label>
    );
    if (this.props.noWrapper) {
      return <div className='control-relative'>{content}</div>;
    }
    return (
      <Wrapper
        showHelpText={this.state.showHelpText}
        helpText={this.props.children}
        noPlaceholders={this.props.noPlaceholders}
      >
        {content}
      </Wrapper>
    );
  }
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/shared/TextInput.js